import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Row, Col, InputGroup } from 'react-bootstrap';
import Button from './Button';
import { comparisonTypes } from './FilterSearchField';
import EditTypesDialog from './EditTypesDialog';
import Select from './Select';
import FormField from './FormField';
import Radio from './Radio';
import CheckBox from './CheckBox';
import FilterSearchField from './FilterSearchField';
import { getFields, findBootstrapEnvironment } from '../../helpers/utils';
import { userFiltersUpdateAction } from '../../actions/userActions';
import { caseSetServerError } from '../../actions/caseActions';
import { isEmptyString } from '../../validators/formValidators';


const defaultFilter = {
    left: '',
    right: '',
    operator: comparisonTypes[0].value,
};

export const getDefaultFilterEntry = () => ({
        type: 'New',
        filterType: 'and',
        archived: false,
        filters: [{...defaultFilter}]
    });

class FilterSearchForm extends PureComponent {
    constructor(props) {
        super(props);
        this.addAction = this.addAction.bind(this);
        this.deleteAction = this.deleteAction.bind(this);
        this.changeAction = this.changeAction.bind(this);
        this.updateComponentFromProps = this.updateComponentFromProps.bind(this);
        this.saveFilters = this.saveFilters.bind(this);
        this.openSaveDialog = this.openSaveDialog.bind(this);
        this.state = {
            filters: [{ ...defaultFilter }],
            type: 'and',
            archived: false,
            workflowFields: [],
            savingNeeded: false,
            selectedFilterIndex: -1,
            loading: false,
            editFiltersOpen: false,
            editFiltersLabel: '',
            editFiltersOnSave: false,
        };
    }

    componentDidMount() {
        this.updateComponentFromProps(this.props);
    }

    componentWillReceiveProps(nextProps) {
        this.updateComponentFromProps(nextProps);
    }

    addAction(index) {
        const filters = [...this.state.filters];
        filters.splice(index + 1, 0, defaultFilter);
        this.setState({ filters, savingNeeded: true });
        if (this.props.onChange) {
            this.props.onChange({
                filters,
                archived: this.state.archived,
                type: this.state.type,
            });
        }
    }

    deleteAction(index) {
        const filters = [...this.state.filters];
        filters.splice(index, 1);
        if (filters.length == 0) {
            filters.push(defaultFilter);
        }

        this.setState({ filters, savingNeeded: true });
        if (this.props.onChange) {
            this.props.onChange({
                filters,
                archived: this.state.archived,
                type: this.state.type,
            });
        }
    }

    changeAction(index, filter) {
        const filters = [...this.state.filters];
        filters[index] = { ...filter };
        this.setState({ filters, savingNeeded: true });
        if (this.props.onChange) {
            this.props.onChange({
                filters,
                archived: this.state.filters.archived,
                type: this.state.type,
            });
        }
    }

    openSaveDialog() {
        this.setState({
            editFiltersOpen: true,
            editFiltersLabel: 'Save Filters As (Select One)',
            editFiltersOnSave: (selectedIndex, filters) => {
                if (selectedIndex < 0) {
                    return;
                }

                this.saveFilters(filters, selectedIndex);
            },
        });
    }

    saveFilters(filters, selectedIndex) {
        if (selectedIndex < 0) {
            return;
        }

        this.setState({ loading: true });
        filters[selectedIndex].filterType = this.state.type;
        filters[selectedIndex].archived = this.state.archived;
        filters[selectedIndex].filters = [...this.state.filters];
        this.props.dispatch(userFiltersUpdateAction(filters, this.props.configFilterName))
            .then((result) => {
                if (!result) {
                    console.error('Error while saving filters.');
                    this.props.dispatch(caseSetServerError('Error while saving filters.'));
                    return;
                }

                this.setState({
                    savingNeeded: false,
                    loading: false,
                    editFiltersOpen: false,
                    editFiltersOnSave: false,
                    selectedFilterIndex: selectedIndex + 1,
                });
            })
            .catch((error) => {
                console.error(new Error().stack, error);
                this.props.dispatch(caseSetServerError(error));
                this.setState({ loading: false });
            });
    }

    updateComponentFromProps(props) {
        if (props.currentConfig && this.state.workflowFields.length === 0) {
            let table;
            if (this.props.recordType === 'case' || this.props.recordType === 'word') {
                table = 'workflow';
            } else {
                table = 'client';
            }

            const workflowFields = getFields(props.currentConfig, false, table).filter((value) => !value.name.startsWith('me.') &&
                       !value.name.startsWith('extra.')).sort((a, b) => {
                const keyA = a.name;
                const keyB = b.name;
                return keyA.localeCompare(keyB);
            });

            this.setState({ workflowFields });
        }

        if (props.filters && (props.filters.filters || props.filters.archived) && this.state.selectedFilterIndex < 1) {
            let filters = [];
            if (props.filters.filters) {
                filters = [...props.filters.filters];
            }

            let type = props.filters.type;
            if (isEmptyString(type)) {
                type = 'and';
            }

            this.setState({
                filters,
                archived: props.filters.archived,
                type,
            });
        }
    }

    render() {
        const {
            savedFilters,
        } = this.props;

        const size = findBootstrapEnvironment();
        const loading = this.props.loading || this.state.loading;
        const filters = this.state.filters.map((filter, index) => (
                <Row key={`filter_row_${index}`} style={{marginTop: size !== 'xs' ? 0 : 15}}>
                    <Col xs={12}>
                        <FilterSearchField rowIndex={index}
                                           filter={filter}
                                           workflowFields={this.state.workflowFields}
                                           loading={loading}
                                           addAction={() => {
                                               this.addAction(index, filter);
                                           }}
                                           deleteAction={() => {
                                               this.deleteAction(index);
                                           }}
                                           changeAction={(index, filter) => {
                                               this.changeAction(index, filter);
                                           }} />
                    </Col>
                </Row>
            ));

        let selectedFilterType = '';
        if (this.state.selectedFilterIndex >= 0 && this.state.selectedFilterIndex < this.props.savedFilters.length) {
            selectedFilterType = this.props.savedFilters[this.state.selectedFilterIndex].type;
        }

        return (
                <div>
                <Row>
                <Col xs={12}>
                <Select label="Load Filter"
                        field={{
                            name: 'Filter',
                            onChange: (evt) => {
                                const type = evt.target.value;
                                const index = this.props.savedFilters.findIndex(item => item.type === type);
                                if (index == 0) {
                                    let filters = {
                                        filters: [{ ...defaultFilter }],
                                        type: 'and',
                                    };

                                    filters = { ...filters, ...this.props.queryFilters };
                                    this.setState({
                                        filters: [...filters.filters],
                                        archived: false,
                                        type: filters.type,
                                    });

                                    if (this.props.onChange) {
                                        this.props.onChange({
                                            filters: [...filters.filters],
                                            archived: false,
                                            type: filters.type,
                                        });
                                    }
                                } else if (index >= 1) {
                                    const filter = this.props.savedFilters[index];
                                    this.setState({
                                        filters: [...filter.filters],
                                        type: filter.filterType,
                                        archived: filter.archived,
                                    });

                                    if (this.props.onChange) {
                                        this.props.onChange({
                                            filters: [...filter.filters],
                                            archived: filter.archived,
                                            type: filter.filterType,
                                        });
                                    }
                                }

                                this.setState({ selectedFilterIndex: index });
                            },
                            value: selectedFilterType,
                        }}
                        disabled={typeof (this.props.savedFilters) === 'undefined' || loading}
                        loading={typeof (this.props.savedFilters) === 'undefined' || loading}
                        options={this.props.savedFilters && this.props.savedFilters.map((filter) => ({label: filter.type}))} 
                />
                </Col>
                </Row>
                <Row>
                    <Col xs={8}>
                        <Radio field={{
                                   name: 'filter_type',
                                   value: this.state.type,
                                   onChange: (evt) => {
                                        this.setState({ type: evt.target.value, savingNeeded: true });
                                        if (this.props.onChange) {
                                            this.props.onChange({
                                                filters: this.state.filters,
                                                archived: this.state.archived,
                                                type: evt.target.value,
                                            });
                                        }
                                   },
                               }}
                               label="Filter rows, where: "
                               name="filter_type"
                               options={[
                                    {
                                        value: 'and',
                                        label: 'All conditions are true',
                                    },
                                    {
                                        value: 'or',
                                        label: 'Any condition is true',
                                    }]}
                        />
                    </Col>
                    <Col xs={4}>
                        <CheckBox field={{
                                      name: 'show_archived',
                                  }}
                                  checked={this.state.archived}
                                  label="Show Archived"
                                  help="If checked, will also show previously archived records."
                                  onChange={() => {
                                      const archived = !this.state.archived;
                                      this.setState({ archived });
                                      if (this.props.onChange) {
                                          this.props.onChange({
                                              filters: this.state.filters,
                                              archived,
                                              type: this.state.type,
                                          });
                                      }
                                  }}
                        />
                    </Col>
                </Row>
                {filters}
                <Row style={{marginTop: size !== 'xs' ? 0 : 20}}>
                <Col xs={6}>
                    <Button onClick={this.openSaveDialog}
                            icon="floppy-disk"
                            style={{ minWidth: '100px' }}
                            tooltip="Save filters for later reuse"
                            label="Save Filter As"
                    />
                </Col>
                <Col xs={6}>
                    <Button onClick={this.props.onSearch}
                            icon="filter"
                            bsStyle="primary"
                            label="Search"
                            tooltip="Search using search box text and applied filters"
                            style={{ minWidth: size !== 'xs' ? '150px' : '100px', float: 'right' }}
                    />
                </Col>
                </Row>
                <EditTypesDialog types={this.props.savedFilters && this.props.savedFilters.filter(filter => filter.type !== '')}
                                 defaultType={getDefaultFilterEntry(this.props.configFilterName)}
                                 open={this.state.editFiltersOpen}
                                 onClose={() => {
                                     this.setState({ editFiltersOpen: false, editFiltersOnSave: false });
                                 }}
                                 label={this.state.editFiltersLabel}
                                 onSave={this.state.editFiltersOnSave}
                                 defaultSelectedIndex={this.state.selectedFilterIndex - 1}
                                 typeLabel="Selected Filter"
                                 loading={this.props.savedFilters == undefined}
                                 modificationDisabled={() => false}
                                 dispatchSaveAction={(filters) => userFiltersUpdateAction(filters, this.props.configFilterName)}
                />
                </div>
        );
    }
}

FilterSearchForm.propTypes = {
    filters: PropTypes.object,
    queryFilters: PropTypes.object,
    loading: PropTypes.bool.isRequired,
    onChange: PropTypes.func,
    configFilterName: PropTypes.string.isRequired,
    recordType: PropTypes.string.isRequired,
};

const mapStateToProps = (state, ownProps) => {
    let filters;
    const currentConfig = state.user.config;
    if (currentConfig && ownProps.configFilterName) {
        if (currentConfig[ownProps.configFilterName]) {
            filters = currentConfig[ownProps.configFilterName];
        } else {
            filters = [];
        }

        if (filters.length === 0 || (filters.length > 0 && filters[0].type !== '')) {
            const filter = getDefaultFilterEntry(ownProps.configFilterName);
            filter.type = '';
            filter.archived = false;
            filters.unshift(filter);
        }
    }

    return {
        currentConfig,
        savedFilters: filters,
    };
};

export default connect(mapStateToProps)(FilterSearchForm);
